// import React from "react";
// import { useState } from "react";
// import { useEffect } from "react";
// import toast from "react-hot-toast";
// import { Link } from "react-router-dom";
// import { base_url } from "../context/Authcontext";
// import axios from "axios";
// import ToastMessage from "./ToastMessage";
// import SupportAndDownloadButtons from "../views/components/SupportAndDownloadButtons";
// export const Footer = () => {
//   const [phoneNumber, setPhoneNumber]= useState();

//   const handleFooterLink = () => {
//     toast.success("Coming Soon!", {
//       position: "top-center",
//       autoClose: 3000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//       theme: "colored",
//     });
//   };

//   const fetchTelegram= async()=> {

//     try{
//       const auth= localStorage.getItem('admin');

//       const response= await axios.get(base_url + '/admin/webapi/get/telegramData',
//         {
//           headers:{
//             'content-type':'application/json',
//             Authorization:`${auth}`,
//           }
//         }
//       )
//       // console.log('respp',response);

//       if(response?.data.success){
//         const data= response?.data.result[0];
//         // console.log('dd',data[0]);
//         const phone= data.whatsappnumber;

//         setPhoneNumber(phone);
//       };

//     }catch(err){
//       ToastMessage(0,'Failed to fetch telegram data');
//     }
//   };

//   const openWhatsAppChat = () => {
//     if (!phoneNumber) {
//       alert("WhatsApp number not available");
//       return;
//     }
//     window.open(`https://wa.me/${phoneNumber}`, "_blank");
//   };

//   useEffect(()=> {
//     fetchTelegram();
//   },[]);



//   return (
//     <>
//       <footer
//         _ngcontent-mkq-c100=""
//         style={{ marginBottom: "45px" }}
//         className="ng-tns-c100-1"
//       >
//         <div
//           _ngcontent-mkq-c100=""
//           className="max-width content-padding ng-tns-c100-1"
//         >
//           <div
//             _ngcontent-mkq-c100=""
//             className="footer-nav-items ng-tns-c100-1"
//           >
//             <app-footer
//               _ngcontent-mkq-c100=""
//               className="ng-tns-c100-1"
//               _nghost-mkq-c92=""
//             >
//               <section
//                 _ngcontent-mkq-c92=""
//                 className="footers-container-second ng-star-inserted"
//               >
//                 <footer _ngcontent-mkq-c92="" className="container">
//                   <div
//                     _ngcontent-mkq-c92=""
//                     className="footer max-width"
//                     style={{ display: "flex", justifyContent: "center" }}
//                   >
//                     <div
//                       _ngcontent-mkq-c92=""
//                       className="links footer-row content-padding w-100"
//                     >
//                       <div
//                         _ngcontent-mkq-c92=""
//                         className="footer-nav max-footer-width"
//                       >
//                         <div _ngcontent-mkq-c92="" className="navbar-header">
//                           <div
//                             _ngcontent-mkq-c92=""
//                             className="social-icons text-left"
//                             style={{ display: "none" }}
//                           >
//                             <ul _ngcontent-mkq-c92="">
//                               <li
//                                 _ngcontent-mkq-c92=""
//                                 className="inline-block"
//                               >
//                                 <Link
//                                   _ngcontent-mkq-c92=""
//                                   href="https://www.facebook.com/btc.bahis"
//                                   target="_blank"
//                                   rel="noopener"
//                                   aria-hidden="true"
//                                   className="icon icon-tb-facebook"
//                                 ></Link>
//                               </li>
//                               <li
//                                 _ngcontent-mkq-c92=""
//                                 className="inline-block"
//                               >
//                                 <Link
//                                   _ngcontent-mkq-c92=""
//                                   href="https://twitter.com/bozdurgitsintr"
//                                   target="_blank"
//                                   rel="noopener"
//                                   aria-hidden="true"
//                                   className="icon icon-tb-twitter"
//                                 ></Link>
//                               </li>
//                               <li
//                                 _ngcontent-mkq-c92=""
//                                 className="inline-block"
//                               >
//                                 <Link
//                                   _ngcontent-mkq-c92=""
//                                   href="https://www.instagram.com/bozdurgitsintr"
//                                   target="_blank"
//                                   rel="noopener"
//                                   aria-hidden="true"
//                                   className="icon icon-tb-instagram"
//                                 ></Link>
//                               </li>
//                             </ul>
//                           </div>
//                         </div>
//                         <div _ngcontent-mkq-c92="">
//                           <div
//                             _ngcontent-mkq-c92=""
//                             className="license-column-holder"
//                           >
//                             <div
//                               _ngcontent-mkq-c92=""
//                               className="download-btn ng-star-inserted"
//                               onClick={handleFooterLink}
//                             >
//                               {/* <Link
//                                 _ngcontent-mkq-c92=""
//                                 className="btn-cls download"
//                                 href="https://app.kheloyaar360.net/"
//                               >
//                                 <img
//                                   _ngcontent-mkq-c92=""
//                                   src="/assets/images/download-icon.svg"
//                                   alt="download-icon_Kheloyaar360"
//                                 />
//                                 <p _ngcontent-mkq-c92="">Download App</p>
//                               </Link> */}
//                             </div>

//                             <div
//                               _ngcontent-mkq-c92=""
//                               style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                               }}
//                             >
//                               {/* <Link
//                                 _ngcontent-mkq-c92=""
//                                 className="btn_wrapper special_border"
//                               >
//                                 <button
//                                   _ngcontent-mkq-c92=""
//                                   type="button"
//                                   className="button-1 for-img"
//                                 >
//                                   <img
//                                     _ngcontent-mkq-c92=""
//                                     src="../public/assets/images/whatsappImages.svg"
//                                     alt="chat icon_Kheloyaar360"
//                                     className="ng-star-inserted"
//                                   />
//                                   <span
//                                     _ngcontent-mkq-c92=""
//                                     className="livebtn ng-star-inserted"
//                                   >
//                                     Get Instant ID on WhatsApp
//                                   </span>
//                                 </button>
//                               </Link> */}
//                             </div>
//                             <div
//                               _ngcontent-mkq-c92=""
//                               className="tut-class ng-star-inserted"
//                             >
//                               <span _ngcontent-mkq-c92="">Tutorials</span>
//                             </div>
//                             <div
//                               _ngcontent-mkq-c92=""
//                               className="tutorials ng-star-inserted"
//                             >
//                               <span
//                                 _ngcontent-mkq-c92=""
//                                 className="special_border ng-star-inserted"
//                                 onClick={handleFooterLink}
//                               >
//                                 <div
//                                   _ngcontent-mkq-c92=""
//                                   className="tutorial-btn"
//                                 >
//                                   <span
//                                     _ngcontent-mkq-c92=""
//                                     className="tut-span"
//                                   >
//                                     <Link _ngcontent-mkq-c92="">
//                                       <div  className="fw-semibold">How to Signup ?</div>
//                                       <div>
//                                         <i
//                                           _ngcontent-mkq-c92=""
//                                           aria-hidden="true"
//                                           className="fa fa-video-camera text-white"
//                                         ></i>
//                                       </div>
//                                     </Link>
//                                   </span>
//                                 </div>
//                               </span>
//                               <span
//                                 _ngcontent-mkq-c92=""
//                                 className="special_border ng-star-inserted"
//                                 onClick={handleFooterLink}
//                               >
//                                 <div
//                                   _ngcontent-mkq-c92=""
//                                   className="tutorial-btn"
//                                 >
//                                   <span
//                                     _ngcontent-mkq-c92=""
//                                     className="tut-span"
//                                   >
//                                     <Link _ngcontent-mkq-c92="">
//                                       <div>How to Login ?</div>
//                                       <div>
//                                         <i
//                                           _ngcontent-mkq-c92=""
//                                           aria-hidden="true"
//                                           className="fa fa-video-camera"
//                                         ></i>
//                                       </div>
//                                     </Link>
//                                   </span>
//                                 </div>
//                               </span>
//                               <span
//                                 _ngcontent-mkq-c92=""
//                                 className="special_border ng-star-inserted"
//                                 onClick={handleFooterLink}
//                               >
//                                 <div
//                                   _ngcontent-mkq-c92=""
//                                   className="tutorial-btn"
//                                 >
//                                   <span
//                                     _ngcontent-mkq-c92=""
//                                     className="tut-span"
//                                   >
//                                     <Link _ngcontent-mkq-c92="">
//                                       <div>How to Deposit ?</div>
//                                       <div>
//                                         <i
//                                           _ngcontent-mkq-c92=""
//                                           aria-hidden="true"
//                                           className="fa fa-video-camera"
//                                         ></i>
//                                       </div>
//                                     </Link>
//                                   </span>
//                                 </div>
//                               </span>
//                               <span
//                                 _ngcontent-mkq-c92=""
//                                 className="special_border ng-star-inserted"
//                                 onClick={handleFooterLink}
//                               >
//                                 <div
//                                   _ngcontent-mkq-c92=""
//                                   className="tutorial-btn"
//                                 >
//                                   <span
//                                     _ngcontent-mkq-c92=""
//                                     className="tut-span"
//                                   >
//                                     <Link _ngcontent-mkq-c92="">
//                                       <div>How to Withdraw ?</div>
//                                       <div>
//                                         <i
//                                           _ngcontent-mkq-c92=""
//                                           aria-hidden="true"
//                                           className="fa fa-video-camera"
//                                         ></i>
//                                       </div>
//                                     </Link>
//                                   </span>
//                                 </div>
//                               </span>
//                               <span
//                                 _ngcontent-mkq-c92=""
//                                 className="special_border ng-star-inserted"
//                                 onClick={handleFooterLink}
//                               >
//                                 <div
//                                   _ngcontent-mkq-c92=""
//                                   className="tutorial-btn"
//                                 >
//                                   <span
//                                     _ngcontent-mkq-c92=""
//                                     className="tut-span"
//                                   >
//                                     <Link _ngcontent-mkq-c92="">
//                                       <div>How to Play ?</div>
//                                       <div>
//                                         <i
//                                           _ngcontent-mkq-c92=""
//                                           aria-hidden="true"
//                                           className="fa fa-video-camera"
//                                         ></i>
//                                       </div>
//                                     </Link>
//                                   </span>
//                                 </div>
//                               </span>
//                             </div>

                          

//                             <div
//                               _ngcontent-mkq-c92=""
//                               className="payment-img-holder ng-star-inserted"
//                             ></div>
//                             <div
//                               _ngcontent-mkq-c92=""
//                               className="footer ng-star-inserted"
//                             >
//                               <div
//                                 _ngcontent-mkq-c92=""
//                                 className="max-footer-width"
//                               >
//                                 <div
//                                   _ngcontent-mkq-c92=""
//                                   className="footer-grid-layout"
//                                 >
//                                   <div
//                                     _ngcontent-mkq-c92=""
//                                     className="curacao"
//                                   >
                                 
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                             <div
//                               _ngcontent-mkq-c92=""
//                               className="footer_link ng-star-inserted  linewish  d-flex justify-content-around"
//                             >
//                                  <div  className="hlpp"> <SupportAndDownloadButtons></SupportAndDownloadButtons></div>


//                               <div
//                                 _ngcontent-mkq-c92=""
//                                 className="primary ng-star-inserted"
//                               >

                                
                                
//                                 <span
//                                   _ngcontent-mkq-c92=""
//                                   className="ng-star-inserted"
//                                 >
//                                   <div
//                               _ngcontent-mkq-c92=""
//                               className="img-holder ng-star-inserted"
//                             >
//                               {/* <div _ngcontent-mkq-c92="" className="row hhpp">
//                                 <img
//                                   _ngcontent-mkq-c92=""
//                                   alt="Logo_Kheloyaar360"
//                                   className="logo"
//                                   src="/assets/images/bigshot11logonew.png"
//                                 />
//                               </div> */}
//                             </div>
                         
//                                 </span>
                               
//                               </div>
//                              <div className="d-flex  gap-5  d-flex justify-content-around">
//                              <div
//                                 _ngcontent-mkq-c92=""
//                                 className="primary ng-star-inserted  text-nowrap"
//                               >

                                
//                                 <span _ngcontent-mkq-c92="" className="header">
//                                   PRIMARY{" "}
//                                 </span>
//                                 <span
//                                   _ngcontent-mkq-c92=""
//                                   className="ng-star-inserted"
//                                 >
//                                   All Sports
//                                 </span>
//                                 <span
//                                   _ngcontent-mkq-c92=""
//                                   className="ng-star-inserted"
//                                 >
//                                   In-Play
//                                 </span>
//                                 <span
//                                   _ngcontent-mkq-c92=""
//                                   className="ng-star-inserted"
//                                 >
//                                   All Casinos
//                                 </span>
//                                 <span
//                                   _ngcontent-mkq-c92=""
//                                   className="ng-star-inserted"
//                                 >
//                                   Blogs
//                                 </span>
//                               </div>

//                               <div
//                                 _ngcontent-mkq-c92=""
//                                 className="setting ng-star-inserted  text-nowrap"
//                               >
//                                 <span _ngcontent-mkq-c92="" className="header">
//                                   SETTINGS
//                                 </span>
//                                 <span
//                                   _ngcontent-mkq-c92=""
//                                   className="ng-star-inserted"
//                                 >
//                                   Contact Us
//                                 </span>
//                                 <span
//                                   _ngcontent-mkq-c92=""
//                                   className="ng-star-inserted"
//                                 >
//                                   Cookie Policy
//                                 </span>
//                                 <span
//                                   _ngcontent-mkq-c92=""
//                                   className="ng-star-inserted"
//                                 >
//                                   Responsible Gambling
//                                 </span>
//                                 <span
//                                   _ngcontent-mkq-c92=""
//                                   className="ng-star-inserted"
//                                 >
//                                   Terms &amp; Conditions
//                                 </span>
//                                 <span
//                                   _ngcontent-mkq-c92=""
//                                   className="ng-star-inserted"
//                                 >
//                                   About Us
//                                 </span>
                                
//                               </div>
//                              </div>
//                               <div
//                                 _ngcontent-mkq-c92=""
//                                 className=" ng-star-inserted  hlp"
//                               >
//                                 <span _ngcontent-mkq-c92="" className="header">
//                                   JOIN OUR COMMUNITY
//                                 </span>
//                               <div  className="d-flex gap-3" >
//                               <a href="https://www.facebook.com/share/1JUCk6qGR6/">
//         <img
//           alt="Facebook_KHELOYAAR"
//           src="https://dabba.b-cdn.net/kheloyaar360.net/banners/223.png"
//           title="Facebook"
//         />
//       </a>
//       <a href={`https://wa.me/${phoneNumber}`}>
//         <img
//           alt="Youtube_KHELOYAAR"
//           src="https://daba.b-cdn.net/global/image-2.svg"
//           title="Whatapp"
//           width="40px"
//         />
//       </a>
//       <a href="https://www.instagram.com/official_bigshot11?igsh=MW5yeWwzcHk2enZjNQ==">
//         <img
//           alt="INSTA_KHELOYAAR"
//           src="https://dabba.b-cdn.net/kheloyaar360.net/banners/225.png"
//           title="INSTA"
//         />
//       </a>
//       <a href="https://t.me/kheloyarclub">
//         <img
//           alt="T_KHELOYAAR"
//           src="https://dabba.b-cdn.net/kheloyaar360.net/banners/226.png"
//           title="T"
//         />
//       </a>
                               
//                               </div>
//                             <div  className="hlpa"> <SupportAndDownloadButtons></SupportAndDownloadButtons></div>
                                
//                               </div>
          
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </footer>
//               </section>
//               <div   style={{ color: "#6c708c", textAlign: "center",paddingTop:"40px" }}>
//       © 2025 Bigshot11.com. All rights reserved.
//     </div>

//               {/* <div _ngcontent-mkq-c92="" className="flexout ng-star-inserted">
//                 <Link
//                   _ngcontent-mkq-c92=""
//                   target="_blank"
//                   href="https://www.facebook.com/kheloyar.official"
//                   className="ng-star-inserted"
//                 >
//                   <img
//                     _ngcontent-mkq-c92=""
//                     className="social2"
//                     alt="Facebook_Kheloyaar360"
//                     src="/assets/images/82.png"
//                   />
//                 </Link>
//                 <Link
//                   _ngcontent-mkq-c92=""
//                   target="_blank"
//                   href="https://x.com/"
//                   className="ng-star-inserted"
//                 >
//                   <img
//                     _ngcontent-mkq-c92=""
//                     className="social2"
//                     alt="twitter_Kheloyaar360"
//                     src="/assets/images/86.png"
//                   />
//                 </Link>
//                 <Link
//                   _ngcontent-mkq-c92=""
//                   target="_blank"
//                   href="https://www.youtube.com/channel/UCC-hnRPCNylFw8usx32y8sQ"
//                   className="ng-star-inserted"
//                 >
//                   <img
//                     _ngcontent-mkq-c92=""
//                     className="social2"
//                     alt="youtube_Kheloyaar360"
//                     src="/assets/images/6.png"
//                   />
//                 </Link>
//                 <Link
//                   _ngcontent-mkq-c92=""
//                   target="_blank"
//                   href="https://www.instagram.com/kheloyar_club_net/"
//                   className="ng-star-inserted"
//                 >
//                   <img
//                     _ngcontent-mkq-c92=""
//                     className="social2"
//                     alt="Instagram_Kheloyaar360"
//                     src="/assets/images/7.png"
//                   />
//                 </Link>
//                 <Link
//                   _ngcontent-mkq-c92=""
//                   target="_blank"
//                   href="https://t.me/kheloyarclub"
//                   className="ng-star-inserted"
//                 >
//                   <img
//                     _ngcontent-mkq-c92=""
//                     className="social2"
//                     alt="Telegram_Kheloyaar360"
//                     src="/assets/images/9.png"
//                   />
//                 </Link>
//               </div> */}
//             </app-footer>
//           </div>
//         </div>
//       </footer>
      // <app-sitefooter
      //   _ngcontent-mkq-c100=""
      //   className="ng-tns-c100-1"
      //   _nghost-mkq-c94=""
      // >
      //   <div
      //     _ngcontent-mkq-c94=""
      //     id="site_footer-settings"
      //     className="site_footer"
      //     style={{ display: "block" }}
      //   >
      //     <div _ngcontent-mkq-c94="" className="site_footer_inn">
      //       <ul _ngcontent-mkq-c94="" className="nav-bottom-site site-ui-inn">
      //         <li _ngcontent-mkq-c94="" className="active">
      //           <Link
      //             _ngcontent-mkq-c94=""
      //             to="/"
      //           >
      //             <img
      //               src="/assets/images/27500.png"
      //               alt=""
      //               _ngcontent-mkq-c94=""
      //               className="sport new_home_icon new_home_icon_yellow"
      //             />
      //             <span _ngcontent-mkq-c94="" className="name-style">
      //               Home
      //             </span>
      //           </Link>
      //         </li>
      //         <li _ngcontent-mkq-c94="">
      //           <Link
      //             to="/live-casino"
      //             _ngcontent-mkq-c94=""
      //             routerlink="/casinos/get/all"
      //           >
      //             <img
      //               src="/assets/images/9383.png"
      //               _ngcontent-mkq-c94=""
      //               className="casino new_casino_icon new_casino_yellow"
      //               alt=""
      //             />
      //             <span _ngcontent-mkq-c94="" className="name-style">
      //               Casinos
      //             </span>
      //           </Link>
      //         </li>
      //         <li
      //           _ngcontent-mkq-c94=""
      //           className="whatsApp-section ng-star-inserted"
      //           onClick={openWhatsAppChat}
      //         >
      //           <Link
      //             _ngcontent-mkq-c94=""
      //             target="_blank"
      //             className="whatsApp circle"
      //           >
      //             <i
      //               _ngcontent-mkq-c94=""
      //               className="fa fa-whatsapp"
      //               aria-hidden="true"
      //             ></i>
      //           </Link>
      //         </li>

      //         <li
      //           _ngcontent-mkq-c94=""
      //           // routerlink="/sports"
      //           className="hide-specific ng-star-inserted"
      //           tabIndex={0}
      //           // onClick={handleFooterLink}
      //         >
      //           <Link _ngcontent-mkq-c94="" to="/sportAll">
      //             <img
      //               src="/assets/images/27498.png"
      //               alt=""
      //               _ngcontent-mkq-c94=""
      //               className="liveCasinoss"
      //             />
      //             <span _ngcontent-mkq-c94="" className="name-style">
      //               Sports
      //             </span>
      //           </Link>
      //         </li>

      //         <li _ngcontent-mkq-c94="">
      //           <Link _ngcontent-mkq-c94="" to='/menu'>
      //             <img
      //               _ngcontent-mkq-c94=""
      //               className="icon-navbar-site"
      //               style={{ maxWidth: "18px" }}
      //               alt="icon_Kheloyaar360"
      //               src="/assets/images/More22.svg"
      //             />
      //             <span _ngcontent-mkq-c94="" className="name-style">
      //               Menu
      //             </span>
      //           </Link>
      //         </li>
      //       </ul>
      //     </div>
      //   </div>
      // </app-sitefooter>
//     </>
//   );
// };


import React from "react";
import { Row, Col } from "react-bootstrap";
// import logo from "../assets/bigshotlogoblack.png";
import {
  FaFacebookF,
  FaYoutube,
  FaInstagram,
  FaTelegramPlane,
  FaWhatsapp,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { base_url } from "../context/Authcontext";
import axios from "axios";
import ToastMessage from "./ToastMessage";
import SupportAndDownloadButtons from "../views/components/SupportAndDownloadButtons";

export const Footer = () => {
  const [phoneNumber, setPhoneNumber] = useState();

  const handleFooterLink = () => {
    toast.success("Coming Soon!", {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const fetchTelegram = async () => {
    try {
      const auth = localStorage.getItem("admin");

      const response = await axios.get(
        base_url + "/admin/webapi/get/telegramData",
        {
          headers: {
            "content-type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );
      // console.log('respp',response);

      if (response?.data.success) {
        const data = response?.data.result[0];
        // console.log('dd',data[0]);
        const phone = data.whatsappnumber;

        setPhoneNumber(phone);
      }
    } catch (err) {
      ToastMessage(0, "Failed to fetch telegram data");
    }
  };

  const openWhatsAppChat = () => {
    if (!phoneNumber) {
      alert("WhatsApp number not available");
      return;
    }
    window.open(`https://wa.me/${phoneNumber}`, "_blank");
  };

  useEffect(() => {
    fetchTelegram();
  }, []);

  return (

 <>
    <footer
      className="footer bg-white text-white pt-5 overflow-hidden"
    >
      <div className="container">
        <h4 className="text-center text-black fw-bold mb-4">TUTORIALS</h4>
        <div className="row justify-content-between mb-5">
          {[
            "How to Signup ?",
            "How to Login ?",
            "How to Deposit ?",
            "How to Withdraw ?",
            "How to Play ?",
          ].map((text, index) => (
            <div className="col-md-3 col-sm-6 mb-3" key={index}>
              <button
                className="bg-warning border-0 responsive-fs p-2 fw-semibold w-100 text-start rounded-1 d-flex justify-content-between align-items-center px-3"
                onClick={handleFooterLink}
              >
                {text} <span className="fw-bold text-white">&#9654;</span>
              </button>
            </div>
          ))}
        </div>

        <div className="row text-start">
          {/* Logo & Description */}
          <div className="col-md-4 mb-4">
            <img src="/assets/images/bigshotlogoblack.png" alt="Logo" width={150} />
            <p className="mt-3 text-light-emphasis fs-6">
              Welcome to BigShot11, the ultimate destination for safe, exciting,
              and profitable online betting! At bigshot11, we are committed to
              providing our users with the highest level of security, ensuring
              your personal information and funds are always protected with
              state-of-the-art encryption technology.
            </p>
          </div>

          {/* Primary Links */}
          <div className="col-6 col-md-2 mb-4">
            <h6 className="fw-bold  text-black" style={{ color: "#000" }}>
              PRIMARY
            </h6>
            <ul className="list-unstyled fs-6 text-light-emphasis">
              <li className="mb-2">All Sports</li>
              <li className="mb-2">In-Play</li>
              <li className="mb-2">All Casinos</li>
              <li className="mb-2">Blogs</li>
            </ul>
          </div>

          {/* Settings Links */}
          <div className="col-6 col-md-3 mb-4">
            <h6 className="fw-bold text-black">SETTINGS</h6>
            <ul className="list-unstyled fs-6 text-light-emphasis">
              <li className="mb-2">Contact Us</li>
              <li className="mb-2">Cookie Policy</li>
              <li className="mb-2">Responsible Gambling</li>
              <li className="mb-2">Terms & Conditions</li>
              <li className="mb-2">About Us</li>
            </ul>
          </div>

          {/* Social Icons */}
          <div className="col-md-3 mb-4">
            <h6 className="fw-bold text-danger">JOIN OUR COMMUNITY</h6>
            <div className="d-flex gap-3 fs-4 mt-2">
              <Link to="https://www.facebook.com/share/1JUCk6qGR6/">
                <FaFacebookF className="social-icon text-primary" />
              </Link>
              <Link onClick={()=>{toast.success("Coming Soon")}}>
                <FaYoutube className="social-icon text-danger" />
              </Link>
              <Link to="https://www.instagram.com/official_bigshot11?igsh=MW5yeWwzcHk2enZjNQ%3D%3D">
                <FaInstagram className="social-icon text-pink" />
              </Link>
              <Link  onClick={()=>{toast.success("Coming Soon")}}>
                <FaTelegramPlane className="social-icon text-info" />
              </Link>
              <Link  onClick={()=>{toast.success("Coming Soon")}}>
                <FaXTwitter className="social-icon text-info" />
              </Link>
            </div>
            {/* <SupportAndDownloadButtons /> */}
          </div>
        </div>
      </div>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/your-number"
        className="whatsapp-btn btn btn-success position-fixed bottom-0 end-0 m-3 d-flex align-items-center rounded-circle"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp className="fs-3" />
        {/* Get an ID on Whatsapp */}
      </a>

      <hr className="bg-secondary" />

      <Row>
        <Col className="text-center text-black">
          <p className="mb-0">
            &copy; {new Date().getFullYear()} BigShot11 All rights reserved.
          </p>
        </Col>
      </Row>
    </footer>

    <app-sitefooter
        _ngcontent-mkq-c100=""
        className="ng-tns-c100-1"
        _nghost-mkq-c94=""
      >
        <div
          _ngcontent-mkq-c94=""
          id="site_footer-settings"
          className="site_footer"
          style={{ display: "block" }}
        >
          <div _ngcontent-mkq-c94="" className="site_footer_inn">
            <ul _ngcontent-mkq-c94="" className="nav-bottom-site site-ui-inn">
              <li _ngcontent-mkq-c94="" className="active">
                <Link
                  _ngcontent-mkq-c94=""
                  to="/"
                >
                  <img
                    src="/assets/images/27500.png"
                    alt=""
                    _ngcontent-mkq-c94=""
                    className="sport new_home_icon new_home_icon_yellow"
                  />
                  <span _ngcontent-mkq-c94="" className="name-style">
                    Home
                  </span>
                </Link>
              </li>
              <li _ngcontent-mkq-c94="">
                <Link
                  to="/casinoGames"
                  _ngcontent-mkq-c94=""
                  routerlink="/casinos/get/all"
                >
                  <img
                    src="/assets/images/9383.png"
                    _ngcontent-mkq-c94=""
                    className="casino new_casino_icon new_casino_yellow"
                    alt=""
                  />
                  <span _ngcontent-mkq-c94="" className="name-style">
                    Casinos
                  </span>
                </Link>
              </li>
              <li
                _ngcontent-mkq-c94=""
                className="whatsApp-section ng-star-inserted"
                onClick={openWhatsAppChat}
              >
                <Link
                  _ngcontent-mkq-c94=""
                  target="_blank"
                  className="whatsApp circle"
                >
                  <i
                    _ngcontent-mkq-c94=""
                    className="fa fa-whatsapp"
                    aria-hidden="true"
                  ></i>
                </Link>
              </li>

              <li
                _ngcontent-mkq-c94=""
                // routerlink="/sports"
                className="hide-specific ng-star-inserted"
                tabIndex={0}
                // onClick={handleFooterLink}
              >
                <Link _ngcontent-mkq-c94="" to="/sportAll">
                  <img
                    src="/assets/images/27498.png"
                    alt=""
                    _ngcontent-mkq-c94=""
                    className="liveCasinoss"
                  />
                  <span _ngcontent-mkq-c94="" className="name-style">
                    Sports
                  </span>
                </Link>
              </li>

              <li _ngcontent-mkq-c94="">
                <Link _ngcontent-mkq-c94="" to='/menu'>
                  <img
                    _ngcontent-mkq-c94=""
                    className="icon-navbar-site"
                    style={{ maxWidth: "18px" }}
                    alt="icon_Kheloyaar360"
                    src="/assets/images/More22.svg"
                  />
                  <span _ngcontent-mkq-c94="" className="name-style">
                    Menu
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </app-sitefooter>
    

</>
  );
};

